import React from "react";

export default function Error({
  size = 12,
  ...rest
}: {
  size?: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25344 0.204659C5.48134 0.0704868 5.73846 0 6 0C6.26154 0 6.51866 0.0704868 6.74656 0.204659C6.97446 0.338832 7.16544 0.53216 7.30108 0.765992L7.30241 0.768284L11.7961 8.61301C11.929 8.85362 11.9993 9.12646 12 9.40431C12.0007 9.68216 11.9319 9.95538 11.8003 10.1968C11.6687 10.4382 11.479 10.6393 11.25 10.7802C11.021 10.9211 10.7607 10.9969 10.495 10.9999L10.4899 11L1.50501 11C1.23931 10.9969 0.979012 10.9211 0.750006 10.7802C0.520998 10.6393 0.331266 10.4382 0.199686 10.1968C0.0681049 9.95538 -0.000738036 9.68216 5.96705e-06 9.40431C0.000749943 9.12646 0.0710552 8.85366 0.203926 8.61304L0.207625 8.60634L4.6976 0.768288L5.09352 1.01629L4.69892 0.765992C4.83456 0.53216 5.02554 0.338832 5.25344 0.204659ZM5.48873 1.26561C5.48853 1.26594 5.48834 1.26627 5.48815 1.2666L1.00172 9.09861C0.950472 9.19256 0.923369 9.29882 0.923079 9.40701C0.922786 9.51632 0.94987 9.62381 1.00163 9.71877C1.0534 9.81374 1.12804 9.89287 1.21813 9.94831C1.30759 10.0034 1.40919 10.0331 1.51296 10.0347H10.487C10.5908 10.0331 10.6924 10.0034 10.7819 9.94831C10.872 9.89287 10.9466 9.81374 10.9984 9.71877C11.0501 9.62381 11.0772 9.51632 11.0769 9.40701C11.0766 9.29881 11.0495 9.19256 10.9983 9.0986L6.51185 1.2666C6.51167 1.26628 6.51148 1.26597 6.5113 1.26565C6.45797 1.17409 6.38305 1.09837 6.2937 1.04577C6.20404 0.992987 6.10289 0.965258 6 0.965258C5.89711 0.965258 5.79596 0.992987 5.7063 1.04577C5.61697 1.09836 5.54205 1.17406 5.48873 1.26561Z"
        fill="#CC3C4E"
      />
    </svg>
  );
}
